import { cn } from '@/lib/utils'
import { Skeleton } from '@/components/ui/skeleton'
import styles from './assets-explorer.module.scss'

export default function AssetsGridSkeleton({
  className,
  isAudio = false,
  hasSearchBar = false,
}: {
  className?: string
  isAudio?: boolean
  hasSearchBar?: boolean
}) {
  return (
    <div className={cn('assets-grid-skeleton tw-flex tw-flex-col tw-gap-2', className)}>
      {hasSearchBar && (
        <div className="tw-flex tw-space-x-2">
          <Skeleton className="tw-h-10 tw-w-full tw-flex-1" />
          <div className="tw-flex tw-flex-1 tw-flex-row tw-space-x-2">
            <Skeleton className="tw-h-10 tw-w-16" />
            <Skeleton className="tw-h-10 tw-w-16" />
            <Skeleton className="tw-h-10 tw-w-16" />
          </div>
        </div>
      )}
      <ul
        className={cn({
          [styles.assetGallery]: !isAudio,
          [styles.audioList]: isAudio,
          'tw-space-y-2': isAudio,
        })}
      >
        {Array.from({ length: 3 }).map((_, index) => (
          <li key={index}>
            <Skeleton
              className={cn({
                'tw-h-[49px] tw-w-full': isAudio,
                'tw-h-[160px] tw-w-full': !isAudio,
              })}
            />
          </li>
        ))}
      </ul>
    </div>
  )
}
